.center {
    text-align: center;
}
